import { Shark } from "shark-mvc";
// import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";

class ContentRelationManager extends ManagerBase {
	constructor () {
		super("contentRelationManager");
		this.remoteClassName = "content-relation";
	}
}

const contentRelationManager = new ContentRelationManager();

Shark.registerController(contentRelationManager);

export default contentRelationManager;
